// extracted by mini-css-extract-plugin
export default {"custom-tab-container":"CustomTabs_custom-tab-container__UvUh-","tabHeader":"CustomTabs_tabHeader__o5iC-"};